import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import { ApplicantProvider } from '@/contexts/ApplicantContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { DashboardLayout } from '@/layouts/DashboardLayout';
import Login from '@/app/auth/Login';
import DashboardPage from '@/app/dashboard/page';
import ApplicationsPage from '@/app/applications/ApplicationsPage';
import ApplicationDetailPage from '@/app/applications/ApplicationDetailPage';
import NotificationsPage from '@/app/notifications/NotificationsPage';
import QueuePage from '@/app/queue/QueuePage';
import ResumesPage from '@/app/resumes/ResumesPage';
import SettingsPage from '@/app/settings/SettingsPage';
import WorkersPage from '@/app/workers/WorkersPage';
import CalendarPage from '@/app/calendar/CalendarPage';

function authed(node: React.ReactNode) {
  return (
    <ProtectedRoute>
      <DashboardLayout>{node}</DashboardLayout>
    </ProtectedRoute>
  );
}

// Vite injects import.meta.env.BASE_URL from vite.config.ts's `base`. For root
// mount it's '/'. For path-mounted deploys it's '/jobs/'. React Router's
// `basename` doesn't want a trailing slash, so strip it.
const ROUTER_BASENAME = (import.meta.env.BASE_URL || '/').replace(/\/$/, '') || '/';

export default function App() {
  return (
    <BrowserRouter basename={ROUTER_BASENAME}>
     <ThemeProvider>
      <AuthProvider>
        <ApplicantProvider>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={authed(<DashboardPage />)} />
            <Route path="/applications" element={authed(<ApplicationsPage />)} />
            <Route
              path="/applications/:id"
              element={authed(<ApplicationDetailPage />)}
            />
            <Route path="/notifications" element={authed(<NotificationsPage />)} />
            <Route path="/queue" element={authed(<QueuePage />)} />
            <Route path="/resumes" element={authed(<ResumesPage />)} />
            <Route path="/workers" element={authed(<WorkersPage />)} />
            <Route path="/calendar" element={authed(<CalendarPage />)} />
            <Route path="/settings" element={authed(<SettingsPage />)} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </ApplicantProvider>
      </AuthProvider>
     </ThemeProvider>
    </BrowserRouter>
  );
}
